import { makeStyles } from 'tss-react/mui'

export const useLabraAiAwsIntegrationBadgeStyles = makeStyles()(theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    width: 'fit-content',
  },
  logo: {
    width: theme.spacing(3.5),
    height: theme.spacing(2),
    objectFit: 'contain',
  },
  label: {
    color: theme.palette.labraText.description,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
}))
